// extracted by mini-css-extract-plugin
module.exports = {"OfferingsCourse":"OfferingsCourse_OfferingsCourse__od4Lt"};